<template>
  <div id="bjzc-invite">
    <PageHeading>{{ $t('invite.name') }}</PageHeading>
    <div class="bjzc-page-content">
      <div class="bjzc-invite-card border-radius" v-html="$getLocaleValue(detail, 'content')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      detail: {
        content: ''
      }
    }
  },
  created() {
    this.$axios.get('single_pages/info', { params: { code: 'invite_join' } }).then(res => {
      this.detail = res.data
    })
    this.$eventBus.$emit('setBreadcrumb', [
      { path: '/', title: '首页', title_en: 'Home' },
      {
        path: '/invite',
        title: this.$t('breadcrumb.invite', 'zh'),
        title_en: this.$t('breadcrumb.invite', 'en')
      }
    ])
  },
  methods: {}
}
</script>

<style lang="scss">
#bjzc-invite {
  .bjzc-invite-card {
    background-color: #fff;
    padding: 2.5rem;
    .with-left-primary-color-bar::before {
      top: 4px;
      bottom: 4px;
    }
    .color-blue {
      color: #1684fd;
      &.with-left-primary-color-bar::before {
        background-color: #1684fd;
      }
    }

    .bjzc-invite-card--row {
      display: flex;
      flex-wrap: wrap;
      & > :nth-child(1) {
        flex: none;
        font-weight: 500;
      }
      & > :nth-child(2) {
      }
      & + .bjzc-invite-card--row {
        margin-top: 1.25rem;
      }
    }
  }
}

@media (max-width: ($screen-width-m - 1)) {
  #bjzc-invite .bjzc-invite-card {
    background-color: transparent;
    padding: 0;
  }
}
</style>
